export const getEmailContent = () => {
    return new Promise((resolve, reject) => {
        const item = Office.context.mailbox?.item;
        if (!item) {
            reject(new Error('No email item available'));
            return;
        }
        item.body.getAsync(Office.CoercionType.Text, (result) => {
            if (result.status === Office.AsyncResultStatus.Succeeded) {
                resolve(result.value);
            }
            else {
                reject(new Error('Failed to get email content: ' + result.error.message));
            }
        });
    });
};
export const getEmailSubject = () => {
    const item = Office.context.mailbox?.item;
    return item?.subject || '';
};
export const getEmailFrom = () => {
    const item = Office.context.mailbox?.item;
    const from = item?.from;
    return from ? from.displayName || from.emailAddress : '';
};
export const getEmailDate = () => {
    const item = Office.context.mailbox?.item;
    const date = item?.dateTimeCreated;
    return date ? date.toLocaleString() : '';
};
export const getEmailContext = async () => {
    try {
        const content = await getEmailContent();
        const subject = getEmailSubject();
        const from = getEmailFrom();
        const date = getEmailDate();
        return `Email Subject: ${subject}
From: ${from}
Date: ${date}

Email Content:
${content}`;
    }
    catch (error) {
        console.error('Error getting email context:', error);
        return 'Unable to retrieve email content.';
    }
};
